import HomeFooter from "../components/layouts/HomeFooter";
import Header from "../components/layouts/Header";
import HomePage from "../components/home";

const Home = (props) => {
  return (
    <>
      <Header />
      <HomePage />
      <HomeFooter />
    </>
  );
};

export default Home;
